module.exports = __webpack_public_path__ + "img/Product_Info.1d8156c7.svg";